<div class="home-layout" [class.is-inside-app]="!isAppManagementRoute" [class.is-outside-app]="isAppManagementRoute">
  <div class="home-rhs">
    <!--loader set to avoid flickering-->
    <div class="body-loader" *ngIf="!isContentReady">
      <div class="body-loader__spinner"></div>
    </div>
    <div
      class="app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header"
      [class.body-hidden]="!isContentReady"
      [ngClass]="{
        'closed-sidebar sidebar-mobile-open': (collapsedMenu$ | async) || isAppManagementRoute,
        'app-mgmn-page': isAppManagementRoute
      }"
    >
      <vb-header [class.d-none]="isBetaAccessPrivilegeConsumableForUser && isAppManagementRoute"></vb-header>

      <!--
    TODO: remove after investigating
    This is needed to show the scrollbar in the menu -->
      <vb-theme-settings></vb-theme-settings>
      <div class="app-main" [class.no-padding]="hasAppId && !isAppManagementRoute && isBetaAccessPrivilegeConsumable">
        <vb-side-bar *ngIf="!isAppManagementRoute && !isBetaAccessPrivilegeConsumable"></vb-side-bar>
        <vb-header-sidebar *ngIf="isAppManagementRoute && isBetaAccessPrivilegeConsumableForUser"></vb-header-sidebar>
        <div class="app-main__outer">
          <div class="app-main__inner p-0" [class.preview-mode]="isPreviewRoute" [class.is-build-route]="isBuildRoute">
            <!-- <vb-page-header></vb-page-header> -->
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
